import { memo, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { adminRoute } from "@/config/roles";
import { Badge2 } from "@/ui2/atoms/Badge";
import { Cell2 } from "@/ui2/atoms/(table)/Cell";
import { Menu2 } from "@/ui2/molecules/Menu";
import { Row2 } from "@/ui2/molecules/(table)/Row";

import type { AdaptedCseRow } from "../../helpers/adapters";

type CseTableRowProps = {
  row: AdaptedCseRow;
};

type CseRowAction = "view_profile";

const ACTION_ITEMS = [{ id: "view_profile", label: "View Profile" }] satisfies {
  id: CseRowAction;
  label: string;
}[];

function CseTableRowComponent({ row }: CseTableRowProps) {
  const history = useHistory();
  const isActive = row.status !== "INACTIVE"; // missing status == active (backend convention)

  const handleActionClick = useCallback(
    (key: CseRowAction) => {
      switch (key) {
        case "view_profile":
          history.push(`${adminRoute}/profile/admin/${row.username}`);
          break;

        default:
          key satisfies never;
      }
    },
    [history, row.username],
  );

  return (
    <Row2 id={row.id}>
      <Cell2>{row.name}</Cell2>
      <Cell2>{row.email}</Cell2>
      <Cell2>{row.mobile || "–"}</Cell2>

      <Cell2>
        <Badge2 size="xs" variant={isActive ? "success" : "neutral"}>
          {isActive ? "Active" : "Inactive"}
        </Badge2>
      </Cell2>

      <Cell2 className="tw:py-3">
        <Menu2
          classNameTrigger="tw:align-middle"
          items={ACTION_ITEMS}
          onAction={handleActionClick}
          placement="left top"
        />
      </Cell2>
    </Row2>
  );
}

export const CseTableRow = memo(CseTableRowComponent);
